import { css } from '@emotion/css';

export const actionButtons = css`
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  display: none;
`;

export const instructorStyles = css`
  &:hover .actionButtons {
    display: flex;
  }
`;

export const editIconPos = css`
  bottom: -1rem;
  right: -0.2rem;
`;

export const mediaContainerMargin = css`
  margin: 0rem;
  img {
    border-radius: 9999px;
  }
  .absolute {
    top: 0;
    right: 0;
  }
`;

export const circleStyle = css``;
